import React from 'react'
import { parseLink } from 'utils'

import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/outline'
import { tx } from '@twind/core'

import { faqs } from '../data/faq'

const FaqPage = () => {
  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
      <div className="lg:grid lg:grid-cols-3 lg:gap-8">
        <div>
          <h1 className="text-3xl font-extrabold text-white">
            Frequently asked questions
          </h1>

          <p className="mt-4 text-lg text-zinc-400">
            Can’t find the answer you’re looking for? Reach out to us at{' '}
            <a
              href="mailto:support@devsnest.in"
              target="_blank"
              rel="noreferrer"
              className="font-medium text-indigo-500 hover:text-indigo-400">
              support@devsnest.in
            </a>
          </p>
        </div>

        <div className="mt-12 lg:mt-0 lg:col-span-2">
          <dl className="">
            {faqs.map((faq) => (
              <Disclosure
                as="div"
                key={faq.question}
                className="pb-4 mb-4 border-b border-zinc-700">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-zinc-400 focus:outline-none">
                        <span className="font-medium text-zinc-100">
                          {faq.question}
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={tx(
                              open ? '-rotate-180' : 'rotate-0',
                              'h-6 w-6 transform'
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>

                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <div
                        className="text-base text-zinc-400"
                        dangerouslySetInnerHTML={{
                          __html: parseLink(faq.answer || '')
                        }}
                      />
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}

FaqPage.seo = {
  title: 'FAQs | Devsnest',
  description:
    'Any inquiries? Check out some of the frequently asked questions. Or, simply get in touch with us via the Contact Us page.',
  canonical: 'https://devsnest.in/faq',
  openGraph: {
    url: 'https://devsnest.in/faq'
  }
}

export default FaqPage
